import React from 'react'
import { YStack, styled, isWeb, useMedia } from 'tamagui'

import { usePalette } from './Palette/PaletteContext'

const CardBase = styled(YStack, {
  name: 'Card',
  borderRadius: '$6',
  backgroundColor: '$backgroundSoft',
  // @ts-expect-error - boxShadow is a web-only property
  boxShadow: '$boxShadowLight',

  padding: '$5',

  variants: {
    main: {
      true: {
        tag: 'main',
      },
    },
  } as const,
} as const)

type CardProps = React.ComponentProps<typeof CardBase> & { glass?: boolean }

export const Card = React.forwardRef<
  React.ElementRef<typeof CardBase>,
  CardProps
>(({ glass, style, ...props }, ref) => {
  const { palette } = usePalette()
  const { reducedMotion: reducedEffects } = useMedia()

  if (!glass || !isWeb || !palette) {
    return <CardBase ref={ref} style={style} {...props} />
  }

  const glassBackground = palette.glassBackground

  return (
    <CardBase
      ref={ref}
      {...props}
      backgroundColor='transparent'
      // style prop accepts web CSS properties on web
      style={{
        backgroundColor: glassBackground,
        ...(reducedEffects
          ? {}
          : {
              backdropFilter: 'blur(16px)',
              WebkitBackdropFilter: 'blur(16px)',
            }),
        ...(typeof style === 'object' ? style : {}),
      }}
    />
  )
})
Card.displayName = 'Card'
